module.exports = __webpack_public_path__ + "public/images/goat-wizard.4824b28cecad634be26df3422e2dc928.webp";